import { TRichSelect } from '@variantjs/vue';

const styles = {
    wrapper: 'relative',
    buttonWrapper: 'inline-block relative w-full',
    selectButton: 'h-50px bg-white border-gray-300 w-full flex text-left justify-between items-center px-3 py-2 text-black transition duration-100 ease-in-out border rounded shadow-sm focus:border-brand-primary_pure focus:ring-1 focus:ring-brand-primary_pure focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed',
    selectButtonLabel: 'block truncate',
    selectButtonPlaceholder: 'text-gray-400 block truncate',
    selectButtonIcon: 'text-gray-600 fill-current flex-shrink-0 ml-1 h-4 w-4',
    selectButtonClearButton: 'hover:bg-blue-100 text-gray-600 rounded flex flex-shrink-0 items-center justify-center absolute right-0 top-0 m-2 h-6 w-6 transition duration-100 ease-in-out',
    selectButtonClearIcon: 'fill-current h-3 w-3',
    dropdown: 'bg-white border-gray-300 absolute w-full z-10 -mt-1 absolute border-b border-l border-r rounded-b shadow-sm z-10',
    dropdownFeedback: 'pb-2 px-3 text-gray-400 text-sm',
    loadingMoreResults: 'pb-2 px-3 text-gray-400 text-sm',
    optionsList: 'overflow-auto',
    searchWrapper: 'p-2 placeholder-gray-400 inline-block w-full',
    searchBox: 'h-50px px-3 py-2 bg-gray-50 text-sm rounded border focus:ring-1 focus:ring-brand-primary_pure focus:outline-none focus:shadow-outline border-gray-300 inline-block w-full',
    optgroup: 'text-gray-400 uppercase text-xs py-1 px-2 font-semibold',
    option: 'cursor-pointer',
    disabledOption: 'opacity-50 cursor-not-allowed',
    highlightedOption: 'bg-blue-100 cursor-pointer',
    selectedOption: 'font-semibold bg-gray-100 bg-blue-500 font-semibold text-white cursor-pointer',
    selectedHighlightedOption: 'font-semibold bg-gray-100 bg-blue-600 font-semibold text-white',
    optionContent: 'flex justify-between items-center px-3 py-2',
    optionLabel: 'truncate block',
    selectedIcon: 'fill-current h-4 w-4',
    enterClass: 'opacity-0',
    enterActiveClass: 'transition ease-out duration-100',
    enterToClass: 'opacity-100',
    leaveClass: 'opacity-100',
    leaveActiveClass: 'transition ease-in duration-75',
    leaveToClass: 'opacity-0',

};
const variants = {
    danger: {
        wrapper: 'relative',
        buttonWrapper: 'inline-block relative w-full',
        selectButton: 'h-50px bg-white border-feedback-danger_pure w-full flex text-left justify-between items-center px-3 py-2 text-black transition duration-100 ease-in-out border rounded shadow-sm focus:border-feedback-danger_pure focus:ring-1 focus:ring-feedback-danger_pure focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed',
        selectButtonLabel: 'block truncate',
        selectButtonPlaceholder: 'text-gray-400 block truncate',
        selectButtonIcon: 'text-gray-600 fill-current flex-shrink-0 ml-1 h-4 w-4',
        selectButtonClearButton: 'hover:bg-blue-100 text-gray-600 rounded flex flex-shrink-0 items-center justify-center absolute right-0 top-0 m-2 h-6 w-6 transition duration-100 ease-in-out',
        selectButtonClearIcon: 'fill-current h-3 w-3',
        dropdown: 'bg-white border-feedback-danger_pure absolute w-full z-10 -mt-1 absolute border-b border-l border-r rounded-b shadow-sm z-10',
        dropdownFeedback: 'pb-2 px-3 text-gray-400 text-sm',
        loadingMoreResults: 'pb-2 px-3 text-gray-400 text-sm',
        optionsList: 'overflow-auto',
        searchWrapper: 'p-2 placeholder-gray-400 inline-block w-full',
        searchBox: 'h-50px px-3 py-2 bg-gray-50 text-sm rounded border focus:ring-1 focus:ring-feedback-danger_pure focus:outline-none focus:shadow-outline border-gray-300 inline-block w-full',
        optgroup: 'text-gray-400 uppercase text-xs py-1 px-2 font-semibold',
        option: 'cursor-pointer',
        disabledOption: 'opacity-50 cursor-not-allowed',
        highlightedOption: 'bg-blue-100 cursor-pointer',
        selectedOption: 'font-semibold bg-gray-100 bg-blue-500 font-semibold text-white cursor-pointer',
        selectedHighlightedOption: 'font-semibold bg-gray-100 bg-blue-600 font-semibold text-white',
        optionContent: 'flex justify-between items-center px-3 py-2',
        optionLabel: 'truncate block',
        selectedIcon: 'fill-current h-4 w-4',
        enterClass: 'opacity-0',
        enterActiveClass: 'transition ease-out duration-100',
        enterToClass: 'opacity-100',
        leaveClass: 'opacity-100',
        leaveActiveClass: 'transition ease-in duration-75',
        leaveToClass: 'opacity-0',
        // As explained in the "Theming" sections we only add the classes we want to override
    },
};

const settings = {
    TRichSelect: {
        component: TRichSelect,
        props: {
            classes: styles,
            variants: variants,
        },
    },
};

export default settings;
